<template>
  <span class="sp-filter-icon" @click.stop>
    <a-icon
        v-if="condition"
        type="filter"
        theme="filled"
    />
    <a-icon
        v-else
        style="color: #005baa"
        type="filter"
        theme="filled"
    />
  </span>
</template>

<script>
export default {
  name: "FilterIcon",
  props: ['condition']
}
</script>
